const normalize = iban => {
  return iban.replace(/[^a-z0-9]/gi, '');
};

export const ibanCountryCode = input => {
  if (!input || input.length < 2) {
    return;
  }

  const iban = normalize(input);
  if (iban.length < 2) {
    return;
  }

  return iban.substring(0, 2).toUpperCase();
};
